import { useEffect, useState, useCallback } from "react";
import { getTrialsByUserIds, type Trial } from "./trials-api";

export function useTrialsForUsers(userIds: string[]) {
  const [trials, setTrials] = useState<Map<string, Trial>>(new Map());
  const key = userIds.join(",");

  const refresh = useCallback(async () => {
    if (!userIds.length) {
      setTrials(new Map());
      return;
    }
    const numericIds = userIds
      .map((id) => parseInt(id, 10))
      .filter((n) => !isNaN(n));
    if (!numericIds.length) {
      setTrials(new Map());
      return;
    }
    try {
      const { trials: list } = await getTrialsByUserIds(numericIds);
      setTrials(new Map(list.map((t) => [String(t.user_id), t])));
    } catch (e) {
      console.error("[useTrialsForUsers]", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { trials, refresh };
}
